<template>
  <div class="template-data-tabs"
       :class="{'main-top-layout': topRoute}"
       v-loading="tabs.loading"
       element-loading-text="页面加载中，请稍等...">
    <div class="data-tabs-content">
      <div class="data-tabs" v-if="tabs.options">
        <div class="data-tabs-pane">
          <el-tabs v-model="tabs.current" type="border-card">
            <el-tab-pane v-for="option in tabs.options" :key="option.name" :name="option.name">
              <span slot="label">
                <!--<i :class="option.icon"></i>-->
                <span>{{option.label}}</span>
              </span>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="data-tabs-router">
          <RouteKeepAlive :route-matches="tabOptionIds"></RouteKeepAlive>
        </div>
      </div>
      <template v-else>
        <Hint class="tabs-load-failed" :icon="false" v-if="!tabs.loading">
          <span>页面加载失败</span>
          <div class="button-group">
            <el-button type="primary" size="mini" plain @click="loadTabsData">点击重试</el-button>
          </div>
        </Hint>
      </template>
    </div>
  </div>
</template>

<script>
import RouteKeepAlive from '../elements/route/RouteKeepAlive'
import baseApiUrl from '../../constants/baseApiUrl'
import routeConfig from '../../constants/routeConfig'
import routeUtils from '../../util/routeUtils'
import fragmentUtils from '../../util/fragmentUtils'
import Support from '../../mixins/support'
import Hint from '../elements/Hint'
export default {
  mixins: [Support],
  name: 'TemplateDataTabs',
  components: {RouteKeepAlive, Hint},
  data () {
    return {
      tabs: {
        loading: false,
        loaded: false,
        options: null,
        current: ''
      }
    }
  },
  computed: {
    tabOptionIds: function () {
      let options = this.tabs.options
      if (options) {
        return options.map(option => option.name)
      } else {
        return null
      }
    }
  },
  methods: {
    dataTabChanged () {
      let options = this.tabs.options
      if (options) {
        let activeTab = options.find(option => option.name === this.tabs.current)
        if (activeTab) {
          let $route = this.$route
          let currentPath = routeUtils.getCurrentRoutePath(this, $route)
          let forwardPath = currentPath + (fragmentUtils.resolvePath(activeTab.name) || activeTab.path)
          // 防止上层跳转时回退
          if ($route.path.startsWith(forwardPath + '/')) {
            return
          }
          let matchId = routeUtils.getRouteMatchId(this, $route)[0]
          if (matchId !== activeTab.name) {
            if (currentPath.startsWith($route.path)) {
              this.$router.replace({ path: forwardPath })
            } else {
              this.$router.push({ path: forwardPath })
            }
          }
        }
      }
    },
    loadTabsData () {
      let postParams = this.$extend(this.$attrs)
      if (!postParams[routeConfig.DataTabs.param]) {
        return
      }
      this.tabs.loading = true
      this.$ajax({
        url: baseApiUrl.DataTabsUrl,
        method: 'post',
        data: this.$qs.stringify(postParams, {
          arrayFormat: 'repeat'
        })
      }).then((response) => {
        if (response.data) {
          let options = response.data['options']
          // 初始化
          this.tabs.options = options
          // 如果没有默认的选项
          if (!this.tabs.current) {
            let matchId = routeUtils.getRouteMatchId(this, this.$route)[0]
            if (matchId) {
              this.tabs.current = matchId
            } else {
              this.tabs.current = response.data['current'] || (options && options.length > 0 ? options[0].name : null)
            }
          }
        }
      }).finally(() => {
        this.tabs.loading = false
        this.tabs.loaded = true
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      let matchId = routeUtils.getRouteMatchId(vm, to)[0]
      if (matchId) {
        vm.tabs.current = matchId
      }
    })
  },
  beforeRouteUpdate (to, from, next) {
    let matchId = routeUtils.getRouteMatchId(this, to)[0]
    if (matchId) {
      next()
      this.$nextTick(() => {
        if (this.tabs.options && this.tabs.options.some(option => option.name === matchId)) {
          this.tabs.current = matchId
        }
      })
    } else {
      if (routeUtils.getCurrentRoutePath(this, to) === routeUtils.getCurrentRoutePath(this, from)) {
        next(false)
      } else {
        next()
      }
    }
  },
  watch: {
    'tabs.current': function () {
      this.dataTabChanged()
    }
  },
  mounted () {
    this.loadTabsData()
  },
  activated () {
    if (this.tabs.loaded) {
      if (this.tabs.options) {
        this.dataTabChanged()
      } else {
        this.loadTabsData()
      }
    }
  }
}
</script>

<style lang="scss">
  .template-data-tabs {
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    &.main-top-layout {
      padding: 10px;
    }
    & > .data-tabs-content {
      position: relative;
      height: 100%;
      & > .data-tabs {
        position: relative;
        height: 100%;
        & > .data-tabs-pane {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          height: 32px;
          .el-tabs {
            position: relative;
            box-shadow: none;
            border: none;
            box-sizing: border-box;
            & > .el-tabs__header {
              height: 32px;
              margin-bottom: 0;
              border-bottom: none;
              background-color: #F8F8F9;
              box-sizing: border-box;
              & > .el-tabs__nav-wrap {
                &.is-scrollable {
                  padding: 0 24px;
                  .el-tabs__nav-prev,
                  .el-tabs__nav-next {
                    width: 24px;
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    font-size: 12px;
                    box-sizing: border-box;
                    i {
                      color: #303133;
                      font-weight: bold;
                    }
                  }
                }
                .el-tabs__nav-scroll {
                  .el-tabs__nav {
                    border: none;
                    border-radius: 0;
                    .el-tabs__active-bar {
                      display: none;
                    }
                    .el-tabs__item {
                      min-width: 100px;
                      height: 32px;
                      font-size: 12px;
                      text-align: center;
                      line-height: 32px;
                      border: none;
                      padding-left: 15px;
                      padding-right: 15px;
                      margin-top: 0;
                      &.is-top {
                        &.is-active {
                          background-color: transparent;
                          &:after {
                            content: '';
                            position: absolute;
                            left: 15px;
                            bottom: 0;
                            right: 15px;
                            height: 2px;
                            background-color: transparent;
                          }
                        }
                      }
                      &:hover,
                      &.is-active {
                        opacity: 1;
                      }
                      i {
                        margin-left: -2px;
                        vertical-align: -2px;
                      }
                    }
                  }
                }
              }
            }
            & > .el-tabs__content {
              display: none;
              visibility: hidden;
            }
          }
        }
        & > .data-tabs-router {
          position: absolute;
          left: 0;
          top: 32px;
          width: 100%;
          bottom: 0;
          background-color: #fff;
          padding-top: 1px;
          box-sizing: border-box;
          overflow: hidden;
          & > * {
            background-color: #f0f2f5;
          }
        }
      }
      .tabs-load-failed {
        .button-group {
          margin: 10px auto;
          text-align: center;
          .el-button {
            padding: 5px 12px;
            border-radius: 0;
          }
        }
      }
    }
  }
</style>
